export default __webpack_public_path__ + "static/media/icon-calendar.19a17ce2.svg";